var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgReportingCountDownIcon = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 9,
    viewBox: "0 0 16 9",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.11114 0L0.888933 0C0.529348 0 0.20532 0.21924 0.0677204 0.5556C-0.0698795 0.89184 0.00609207 1.27896 0.260313 1.53636L7.3714 8.73636C7.53816 8.9052 7.76429 9 8.00002 9C8.23576 9 8.46189 8.9052 8.62853 8.73636L15.7396 1.53636C15.9938 1.27896 16.0699 0.89184 15.9323 0.5556C15.7947 0.21924 15.4706 0 15.1111 0L8.88891 0L7.11114 0Z",
    fill: "#2E2BEB"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgReportingCountDownIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ReportingCountDownIcon.f85132ad.svg";
export { ForwardRef as ReactComponent };